var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',_vm._g(_vm._b({ref:"form",staticClass:"app-form"},'v-form',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"app-form__fields"},[_vm._t("default")],2),(_vm.$slots.actions)?_c('div',{staticClass:"app-form__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }